import { render, staticRenderFns } from "./AccordionField.vue?vue&type=template&id=7d8c637b&"
import script from "./AccordionField.vue?vue&type=script&lang=js&"
export * from "./AccordionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccordionField.vue"
export default component.exports